import * as React from "react";
import * as _ from "lodash";
import { FormProvider, useForm } from "react-hook-form";
import { SelectInput } from "../../components/forms/inputs/SelectInput";

interface OwnProps {
  onSubmit: Function;
  currentFilters: any;
}

const DAYS = {
  MONDAY: "Monday",
  TUESDAY: "Tuesday",
  WEDNESDAY: "Wednesday",
  THURSDAY: "Thursday",
  FRIDAY: "Friday",
  SATURDAY: "Saturday",
  SUNDAY: "Sunday",
};

const daysOptions = [
  {
    label: DAYS.MONDAY,
    value: DAYS.MONDAY,
  },
  {
    label: DAYS.TUESDAY,
    value: DAYS.TUESDAY,
  },
  {
    label: DAYS.WEDNESDAY,
    value: DAYS.WEDNESDAY,
  },
  {
    label: DAYS.THURSDAY,
    value: DAYS.THURSDAY,
  },
  {
    label: DAYS.FRIDAY,
    value: DAYS.FRIDAY,
  },
  {
    label: DAYS.SATURDAY,
    value: DAYS.SATURDAY,
  },
  {
    label: DAYS.SUNDAY,
    value: DAYS.SUNDAY,
  },
];

export const TimeslotsListFilters: React.FC<OwnProps> = (props) => {
  const methods = useForm({
    defaultValues: {
      ...props.currentFilters,
    },
  });
  const handleSubmit = (values: { [key: string]: any }) => {
    props.onSubmit(_.omitBy(values, (x) => x === ""));
  };

  return (
    /* @ts-ignore */
    <FormProvider {...methods}>
      <form>
        <div>
          <SelectInput
            name="day"
            label="Day of week"
            options={daysOptions}
            onChange={() => methods.handleSubmit(handleSubmit)()}
          />
        </div>
      </form>
    </FormProvider>
  );
};

export default TimeslotsListFilters;
